////
/// ============================================================================
/// COMPONENT / Swiper Product Single
/// ============================================================================
///
/// @link https://swiperjs.com/
/// @link https://codepen.io/xgad/post/svg-radial-progress-meters
/// @group components
////

import Swiper, {
  FreeMode,
  Manipulation,
  Navigation,
  Pagination,
  Thumbs,
} from "swiper";

Swiper.use([FreeMode, Manipulation, Navigation, Pagination, Thumbs]);

export default () => {
  let container = document.querySelector(".js-product-gallery");

  if (!container) {
    return;
  }

  let thumbsContainer = container.querySelector(".js-product-gallery-thumbs");
  let topContainer = container.querySelector(".js-product-gallery-top");

  let galleryTopOptions = {
    spaceBetween: 10,
    loopedSlides: 4, // looped slides should be the same
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  };

  window.hmk_shelf_galleryThumbs = new Swiper(thumbsContainer, {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    loopedSlides: 4, // looped slides should be the same
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });

  galleryTopOptions.thumbs = {
    swiper: window.hmk_shelf_galleryThumbs,
  };

  window.hmk_shelf_galleryTop = new Swiper(topContainer, galleryTopOptions);
  window.dispatchEvent(new CustomEvent("hmk:shelf-gallery-ready"));
};
